import React from 'react';
import { Plus } from 'lucide-react';
import { cn } from '@/utils/cn';

interface AddButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
}

export const AddButton: React.FC<AddButtonProps> = ({
  label = 'Nouveau',
  className,
  type = 'button',
  ...props
}) => {
  return (
    <button
      type={type}
      {...props}
      className={cn(
        'flex items-center justify-center gap-2 px-4 py-2 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white rounded-lg shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:active:scale-100 disabled:hover:shadow-lg',
        className,
      )}
    >
      <Plus className="h-4 w-4" />
      <span>{label}</span>
    </button>
  );
};
